
<div
>
    <v-alert
        color  = "error"
        v-if   = "errortext"
        class  = "pa-2 white--text mr-3"
        v-html = "errortext"
    />

    <v-container
        v-if   = "hasFaults"
        class  = "fault-panel"
        :style = "'max-height:' + height + 'px; height:' + h + 'px'"
    >
        <div
            v-for="(item, index) in faults"
            :key="index"
        >
            <div class="v-flex " :class="index < faults.length - 1 ? 'mb-4' : ''">
                <div>
                    <v-checkbox
                        v-if="needsCommitment(item)"
                        v-model="item.confirmed"
                        style         = "margin-left: 2px; margin-top: -4px"
                        class         = "mt-0"
                        background-color="white"
                        :hide-details = true
                        :ripple       = false
                    />

                    <div
                        class="fault-rating"
                        :class="color(item)"
                        @contextmenu="show"
                        :data-index="index"
                        :style="needsCommitment( item) ? 'height: 110px;' : 'height: 138px;'"
                    >
                        {{ ratingName(item.rating) }}
                    </div>
                </div>

                <v-menu
                    v-model="showMFaultMenu"
                    :position-x="x"
                    :position-y="y"
                    absolute
                    offset-y
                >
                    <v-list>
                        <v-list-item link @click="onCopy(item.description)">
                            <v-list-item-title>Text kopieren</v-list-item-title>
                        </v-list-item>
                        <v-divider class="mt-2 mb-2" />
                        <v-list-item
                            v-for = "(rating, index) in items"
                            class = "pl-0"
                            :key  = "index"
                            @click = "onChangeType (item, rating)"
                            link
                        >
                            <v-list-item-title
                                class="pl-2"
                            >
                                <v-icon color="black" size="20">mdi-chevron-right</v-icon> {{ rating.name }}
                            </v-list-item-title>
                        </v-list-item>
                        <v-divider class="mt-2 mb-2" />
                        <v-list-item link @click="onDelete(item)">
                            <v-list-item-title class="red--text v-flex">
                                <v-icon color="red" size="22">mdi-delete</v-icon>
                                <div style="margin-top: 2px">Löschen</div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-textarea
                    v-model        = "item.description"
                    rows           = "6"
                    class          = "mt-0 pt-0 pr-1"
                    ref            = "description"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :readonly      = "readonly"
                    :disabled      = "readonly"
                    no-resize
                    hide-details
                />
            </div>
        </div>
    </v-container>
    <div class="mt-0 v-flex" style="justify-content: space-between" v-if="!readonly">
        <v-menu
            v-model="showMenu"
            absolute
            offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <div
                    v-bind = "attrs"
                    v-on   = "on"
                    class  = "pt-1"
                >
                    <i class="fas fa-plus"></i>
                    <span class="ml-2">{{ $t('inc.assessment.addFault') }}</span>
                </div>
            </template>

            <v-list>
                <v-list-item
                    v-for  = "(item, index) in items"
                    :key   = "index"
                    @click = "onAdd(item)"
                >
                    <v-list-item-title >{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>

</div>
